(() => {
  if (window.__FAJ_SERVICE_PRODUCT_V13__) return;
  window.__FAJ_SERVICE_PRODUCT_V13__ = true;

  const instances = new WeakMap();

  class FajServiceProductV13 {
    constructor(section) {
      this.section = section;
      this.carousel = section.querySelector('[data-fajsp-flickity]');
      this.slides = Array.from(section.querySelectorAll('[data-fajsp-slide]'));
      this.thumbnails = Array.from(
        section.querySelectorAll('[data-fajsp-thumbnail]')
      );
      this.previousButton = section.querySelector('[data-fajsp-previous]');
      this.nextButton = section.querySelector('[data-fajsp-next]');
      this.currentCounter = section.querySelector(
        '[data-fajsp-current-slide]'
      );
      this.totalCounter = section.querySelector(
        '[data-fajsp-total-slides]'
      );

      this.modal = section.querySelector('[data-fajsp-booking-modal]');
      this.openButton = section.querySelector('[data-fajsp-open-booking]');
      this.closeButton = section.querySelector('[data-fajsp-close-booking]');
      this.cancelButton = section.querySelector('[data-fajsp-cancel-booking]');
      this.dismissSuccessButton = section.querySelector(
        '[data-fajsp-dismiss-success]'
      );
      this.form = section.querySelector(
        '[data-fajsp-external-booking-form]'
      );
      this.formStatus = section.querySelector('[data-fajsp-form-status]');
      this.submitButton = section.querySelector(
        '[data-fajsp-submit-booking]'
      );
      this.successPanel = section.querySelector(
        '[data-fajsp-booking-success]'
      );
      this.successWhatsapp = section.querySelector(
        '[data-fajsp-success-whatsapp]'
      );
      this.layout = section.querySelector('.fajsp__layout');
      this.stickyAncestors = [];
      this.stickyPrepared = false;
      this.headerObservers = [];
      this.headerResizeObserver = null;
      this.headerOffsetFrame = 0;
      this.headerGuardFrame = 0;
      this.headerGuardUntil = 0;
      this.lastScrollY = window.scrollY;
      this.headerSelector =
        section.dataset.stickyHeaderSelector?.trim() || '#scrollHeader';

      this.loop = section.dataset.galleryLoop === 'true';
      this.currentIndex = Math.max(
        0,
        this.slides.findIndex((slide) =>
          slide.classList.contains('is-active')
        )
      );

      this.flickity = null;
      this.flickityWaitTimer = null;
      this.flickityWaitAttempts = 0;
      this.resizeFrame = 0;
      this.submitting = false;

      this.onThumbnailClick = this.onThumbnailClick.bind(this);
      this.onPreviousClick = this.onPreviousClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onSliderKeydown = this.onSliderKeydown.bind(this);
      this.onResize = this.onResize.bind(this);
      this.openModal = this.openModal.bind(this);
      this.closeModal = this.closeModal.bind(this);
      this.onModalClick = this.onModalClick.bind(this);
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
      this.onFormSubmit = this.onFormSubmit.bind(this);
      this.updateStickyHeaderOffset =
        this.updateStickyHeaderOffset.bind(this);
      this.scheduleStickyHeaderOffset =
        this.scheduleStickyHeaderOffset.bind(this);
      this.onStickyHeaderScroll =
        this.onStickyHeaderScroll.bind(this);
      this.runHeaderCollisionGuard =
        this.runHeaderCollisionGuard.bind(this);
    }

    init() {
      this.bindGalleryControls();
      this.bindBookingControls();

      if (this.totalCounter) {
        this.totalCounter.textContent = String(this.slides.length);
      }

      this.updateActiveState(false);
      this.waitForFlickity();
      this.prepareNativeSticky();
      this.observeStickyHeaders();
      this.updateStickyHeaderOffset();
    }

    bindGalleryControls() {
      this.thumbnails.forEach((button) => {
        button.addEventListener('click', this.onThumbnailClick);
      });

      this.previousButton?.addEventListener(
        'click',
        this.onPreviousClick
      );
      this.nextButton?.addEventListener('click', this.onNextClick);
      this.carousel?.addEventListener('keydown', this.onSliderKeydown);
      window.addEventListener('resize', this.onResize, {
        passive: true
      });
    }

    bindBookingControls() {
      this.openButton?.addEventListener('click', this.openModal);
      this.closeButton?.addEventListener('click', this.closeModal);
      this.cancelButton?.addEventListener('click', this.closeModal);
      this.dismissSuccessButton?.addEventListener(
        'click',
        this.closeModal
      );
      this.modal?.addEventListener('click', this.onModalClick);
      this.form?.addEventListener('submit', this.onFormSubmit);
      document.addEventListener('keydown', this.onDocumentKeydown);
    }

    getHeaderCandidates() {
      const selectors = [
        this.headerSelector,
        '#scrollHeader',
        '.scroll-header',
        '.scroll-header.visible',
        '.shopify-section-header-sticky',
        '.header-wrapper--sticky',
        'sticky-header',
        '[data-sticky-header]'
      ].filter(Boolean).join(',');

      try {
        return Array.from(document.querySelectorAll(selectors));
      } catch (error) {
        return Array.from(
          document.querySelectorAll(
            '#scrollHeader,.scroll-header,.scroll-header.visible'
          )
        );
      }
    }

    getVisibleHeaderBottom() {
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;

      let bottom = 0;

      this.getHeaderCandidates().forEach((element) => {
        if (!element || element.closest('[data-fajsp]')) return;

        const styles = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();

        const visible =
          styles.display !== 'none' &&
          styles.visibility !== 'hidden' &&
          Number(styles.opacity || 1) > 0.01 &&
          rect.width > 0 &&
          rect.height > 0;

        const topOverlay =
          ['fixed', 'sticky'].includes(styles.position) &&
          rect.bottom > 0 &&
          rect.top < Math.min(240, viewportHeight * 0.35);

        if (visible && topOverlay) {
          bottom = Math.max(
            bottom,
            Math.min(rect.bottom, viewportHeight)
          );
        }
      });

      return Math.max(0, Math.ceil(bottom));
    }

    updateStickyHeaderOffset() {
      this.headerOffsetFrame = 0;

      if (!window.matchMedia('(min-width: 990px)').matches) {
        this.section.style.setProperty(
          '--fajsp-fixed-header-bottom',
          '0px'
        );
        return;
      }

      const headerBottom = this.getVisibleHeaderBottom();

      this.section.style.setProperty(
        '--fajsp-fixed-header-bottom',
        `${headerBottom}px`
      );
    }

    scheduleStickyHeaderOffset() {
      if (this.headerOffsetFrame) return;

      this.headerOffsetFrame = window.requestAnimationFrame(
        this.updateStickyHeaderOffset
      );
    }

    runHeaderCollisionGuard(timestamp) {
      this.updateStickyHeaderOffset();

      if (timestamp < this.headerGuardUntil) {
        this.headerGuardFrame = window.requestAnimationFrame(
          this.runHeaderCollisionGuard
        );
      } else {
        this.headerGuardFrame = 0;
      }
    }

    startHeaderCollisionGuard(duration = 550) {
      this.headerGuardUntil = performance.now() + duration;

      if (!this.headerGuardFrame) {
        this.headerGuardFrame = window.requestAnimationFrame(
          this.runHeaderCollisionGuard
        );
      }
    }

    onStickyHeaderScroll() {
      const currentScrollY = window.scrollY;
      const scrollingUp = currentScrollY < this.lastScrollY;
      this.lastScrollY = currentScrollY;

      this.scheduleStickyHeaderOffset();

      if (scrollingUp) {
        this.startHeaderCollisionGuard();
      }
    }

    observeStickyHeaders() {
      const headers = this.getHeaderCandidates();

      headers.forEach((header) => {
        const observer = new MutationObserver(() => {
          this.scheduleStickyHeaderOffset();
          this.startHeaderCollisionGuard();
        });

        observer.observe(header, {
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden']
        });

        this.headerObservers.push(observer);
      });

      if ('ResizeObserver' in window && headers.length) {
        this.headerResizeObserver = new ResizeObserver(() => {
          this.scheduleStickyHeaderOffset();
          this.startHeaderCollisionGuard(350);
        });

        headers.forEach((header) => {
          this.headerResizeObserver.observe(header);
        });
      }

      window.addEventListener(
        'scroll',
        this.onStickyHeaderScroll,
        { passive: true }
      );
    }

    disconnectStickyHeaderObservers() {
      this.headerObservers.forEach((observer) => observer.disconnect());
      this.headerObservers = [];

      this.headerResizeObserver?.disconnect();
      this.headerResizeObserver = null;

      window.removeEventListener(
        'scroll',
        this.onStickyHeaderScroll
      );

      if (this.headerOffsetFrame) {
        window.cancelAnimationFrame(this.headerOffsetFrame);
        this.headerOffsetFrame = 0;
      }

      if (this.headerGuardFrame) {
        window.cancelAnimationFrame(this.headerGuardFrame);
        this.headerGuardFrame = 0;
      }

      this.section.style.removeProperty(
        '--fajsp-fixed-header-bottom'
      );
    }

    prepareNativeSticky() {
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      const stickyEnabled =
        this.section.dataset.stickyMedia === 'true' ||
        this.section.dataset.stickyBooking === 'true';

      if (!desktop || !stickyEnabled || !this.layout) {
        this.restoreStickyAncestors();
        return;
      }

      if (this.stickyPrepared) return;

      /*
       * Native position: sticky stops working when a non-scrolling ancestor
       * clips overflow. Neutralize only clipping ancestors that are not real
       * vertical scrolling containers, matching the existing FAJ product and
       * collection-sidebar implementation.
       */
      let ancestor = this.section.parentElement;

      while (ancestor && ancestor !== document.body) {
        const styles = window.getComputedStyle(ancestor);
        const overflowValues = [
          styles.overflow,
          styles.overflowX,
          styles.overflowY
        ];

        const clipsSticky = overflowValues.some((value) =>
          ['hidden', 'clip', 'auto', 'scroll'].includes(value)
        );

        const isActualVerticalScroller =
          ancestor.scrollHeight > ancestor.clientHeight + 2 &&
          ['auto', 'scroll'].includes(styles.overflowY);

        if (clipsSticky && !isActualVerticalScroller) {
          ancestor.classList.add('fajsp-sticky-overflow-fix');
          this.stickyAncestors.push(ancestor);
        }

        ancestor = ancestor.parentElement;
      }

      this.stickyPrepared = true;
    }

    restoreStickyAncestors() {
      this.stickyAncestors.forEach((ancestor) => {
        ancestor.classList.remove('fajsp-sticky-overflow-fix');
      });

      this.stickyAncestors = [];
      this.stickyPrepared = false;
    }

    waitForFlickity() {
      if (!this.carousel || this.slides.length <= 1) {
        this.updateActiveState(false);
        return;
      }

      if (typeof window.Flickity !== 'undefined') {
        this.initFlickity();
        return;
      }

      this.flickityWaitAttempts += 1;

      if (this.flickityWaitAttempts > 60) {
        console.warn(
          'FAJ service gallery: Flickity was not available on this page.'
        );
        return;
      }

      this.flickityWaitTimer = window.setTimeout(() => {
        this.waitForFlickity();
      }, 100);
    }

    initFlickity() {
      if (
        this.flickity ||
        !this.carousel ||
        typeof window.Flickity === 'undefined'
      ) {
        return;
      }

      this.flickity = new window.Flickity(this.carousel, {
        cellAlign: 'left',
        contain: true,
        draggable: true,
        adaptiveHeight: false,
        setGallerySize: false,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: this.loop,
        initialIndex: this.currentIndex,
        accessibility: true,
        percentPosition: true,
        selectedAttraction: 0.025,
        friction: 0.28
      });

      this.flickity.on('ready', () => {
        this.currentIndex = this.flickity.selectedIndex || 0;
        this.updateActiveState(false);
        this.flickity.resize();
      });

      this.flickity.on('change', (index) => {
        this.currentIndex = index;
        this.updateActiveState(true);
      });

      this.flickity.on('settle', (index) => {
        this.currentIndex = index;
        this.updateActiveState(true);
      });

      this.slides.forEach((slide) => {
        slide.querySelectorAll('img').forEach((image) => {
          if (image.complete) return;
          image.addEventListener(
            'load',
            () => this.flickity?.resize(),
            { once: true }
          );
        });
      });

      window.requestAnimationFrame(() => {
        this.flickity?.resize();
        this.flickity?.select(this.currentIndex, false, true);
      });
    }

    normalizeIndex(index) {
      const count = this.slides.length;
      if (!count) return 0;

      if (this.loop) {
        return ((index % count) + count) % count;
      }

      return Math.min(Math.max(index, 0), count - 1);
    }

    selectSlide(index, instant = false) {
      const targetIndex = this.normalizeIndex(index);
      this.currentIndex = targetIndex;

      if (this.flickity) {
        this.flickity.select(targetIndex, this.loop, instant);
      } else {
        this.updateActiveState(true);
      }
    }

    scrollThumbnailHorizontally(thumbnail) {
      if (!thumbnail) return;

      const strip = thumbnail.closest('[data-fajsp-thumbnails]');
      if (!strip) return;

      const stripRect = strip.getBoundingClientRect();
      const thumbnailRect = thumbnail.getBoundingClientRect();
      let horizontalDelta = 0;

      if (thumbnailRect.left < stripRect.left) {
        horizontalDelta = thumbnailRect.left - stripRect.left;
      } else if (thumbnailRect.right > stripRect.right) {
        horizontalDelta = thumbnailRect.right - stripRect.right;
      }

      if (Math.abs(horizontalDelta) < 1) return;

      strip.scrollTo({
        left: strip.scrollLeft + horizontalDelta,
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth'
      });
    }

    updateActiveState(scrollThumbnail = true) {
      this.slides.forEach((slide, index) => {
        const active = index === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.thumbnails.forEach((thumbnail, index) => {
        const active = index === this.currentIndex;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute(
          'aria-current',
          active ? 'true' : 'false'
        );

        if (active && scrollThumbnail) {
          this.scrollThumbnailHorizontally(thumbnail);
        }
      });

      if (this.currentCounter) {
        this.currentCounter.textContent = String(this.currentIndex + 1);
      }

      if (!this.loop) {
        if (this.previousButton) {
          this.previousButton.disabled = this.currentIndex === 0;
        }

        if (this.nextButton) {
          this.nextButton.disabled =
            this.currentIndex === this.slides.length - 1;
        }
      }
    }

    onThumbnailClick(event) {
      event.preventDefault();
      const index = Number(event.currentTarget.dataset.slideIndex);
      if (Number.isFinite(index)) this.selectSlide(index);
    }

    onPreviousClick(event) {
      event?.preventDefault();
      event?.stopPropagation();

      if (this.flickity) {
        this.flickity.previous(this.loop);
      } else {
        this.selectSlide(this.currentIndex - 1);
      }
    }

    onNextClick(event) {
      event?.preventDefault();
      event?.stopPropagation();

      if (this.flickity) {
        this.flickity.next(this.loop);
      } else {
        this.selectSlide(this.currentIndex + 1);
      }
    }

    onSliderKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.onPreviousClick();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.onNextClick();
      } else if (event.key === 'Home') {
        event.preventDefault();
        this.selectSlide(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        this.selectSlide(this.slides.length - 1);
      }
    }

    onResize() {
      if (this.resizeFrame) return;

      this.resizeFrame = window.requestAnimationFrame(() => {
        this.resizeFrame = 0;
        this.flickity?.resize();
        this.flickity?.select(this.currentIndex, false, true);
        this.prepareNativeSticky();
        this.scheduleStickyHeaderOffset();
      });
    }

    openModal() {
      if (!this.modal) return;

      this.showForm();

      if (typeof this.modal.showModal === 'function') {
        if (!this.modal.open) this.modal.showModal();
      } else {
        this.modal.setAttribute('open', '');
      }

      document.documentElement.style.overflow = 'hidden';
    }

    closeModal() {
      if (!this.modal) return;

      if (
        typeof this.modal.close === 'function' &&
        this.modal.open
      ) {
        this.modal.close();
      } else {
        this.modal.removeAttribute('open');
      }

      document.documentElement.style.removeProperty('overflow');
    }

    onModalClick(event) {
      if (event.target === this.modal) {
        this.closeModal();
      }
    }

    onDocumentKeydown(event) {
      if (event.key === 'Escape' && this.modal?.open) {
        this.closeModal();
      }
    }

    setStatus(message = '', type = '') {
      if (!this.formStatus) return;

      this.formStatus.textContent = message;
      this.formStatus.classList.remove('is-error', 'is-success');

      if (type) {
        this.formStatus.classList.add(`is-${type}`);
      }
    }

    setSubmitting(active) {
      this.submitting = active;

      if (!this.submitButton) return;

      this.submitButton.disabled =
        active || !this.form?.action || this.form.action === window.location.href;

      const label = this.submitButton.querySelector('span');

      if (label) {
        if (!label.dataset.originalText) {
          label.dataset.originalText = label.textContent.trim();
        }

        label.textContent = active
          ? 'Sending Request…'
          : label.dataset.originalText;
      }
    }

    buildWhatsappConfirmation(formData) {
      if (!this.successWhatsapp) return;

      const product = formData.get('service_product') || '';
      const name = formData.get('name') || '';
      const phone = formData.get('phone') || '';
      const area = formData.get('area') || '';
      const date = formData.get('date') || '';
      const time = formData.get('time_slot') || '';

      const message = [
        'Hello, I have submitted a service booking request.',
        `Service: ${product}`,
        `Name: ${name}`,
        `Phone: ${phone}`,
        `Area: ${area}`,
        `Date: ${date}`,
        `Time: ${time}`
      ].join('\n');

      const base = this.successWhatsapp.href.split('?')[0];
      this.successWhatsapp.href =
        `${base}?text=${encodeURIComponent(message)}`;
    }

    showSuccess(formData) {
      if (this.form) this.form.hidden = true;
      if (this.successPanel) this.successPanel.hidden = false;
      this.buildWhatsappConfirmation(formData);
    }

    showForm() {
      if (this.form) this.form.hidden = false;
      if (this.successPanel) this.successPanel.hidden = true;
      this.setStatus();
    }

    async onFormSubmit(event) {
      event.preventDefault();

      if (!this.form || this.submitting) return;

      if (!this.form.reportValidity()) return;

      const endpoint = this.form.getAttribute('action')?.trim();

      if (!endpoint) {
        this.setStatus(
          'Add the Formspree endpoint in the Theme Editor before submitting.',
          'error'
        );
        return;
      }

      const formData = new FormData(this.form);

      if (String(formData.get('website') || '').trim()) {
        return;
      }

      this.setStatus();
      this.setSubmitting(true);

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          let message = 'The booking request could not be sent. Please try again.';

          try {
            const payload = await response.json();
            if (Array.isArray(payload?.errors) && payload.errors[0]?.message) {
              message = payload.errors[0].message;
            } else if (payload?.error) {
              message = payload.error;
            }
          } catch (error) {
            // Keep generic error.
          }

          throw new Error(message);
        }

        this.showSuccess(formData);
        this.form.reset();
      } catch (error) {
        this.setStatus(
          error?.message ||
            'The booking request could not be sent. Please try again.',
          'error'
        );
      } finally {
        this.setSubmitting(false);
      }
    }

    destroy() {
      if (this.flickityWaitTimer) {
        window.clearTimeout(this.flickityWaitTimer);
      }

      if (this.resizeFrame) {
        window.cancelAnimationFrame(this.resizeFrame);
      }

      this.thumbnails.forEach((button) => {
        button.removeEventListener('click', this.onThumbnailClick);
      });

      this.previousButton?.removeEventListener(
        'click',
        this.onPreviousClick
      );
      this.nextButton?.removeEventListener(
        'click',
        this.onNextClick
      );
      this.carousel?.removeEventListener(
        'keydown',
        this.onSliderKeydown
      );
      window.removeEventListener('resize', this.onResize);

      this.openButton?.removeEventListener('click', this.openModal);
      this.closeButton?.removeEventListener('click', this.closeModal);
      this.cancelButton?.removeEventListener('click', this.closeModal);
      this.dismissSuccessButton?.removeEventListener(
        'click',
        this.closeModal
      );
      this.modal?.removeEventListener('click', this.onModalClick);
      this.form?.removeEventListener('submit', this.onFormSubmit);
      document.removeEventListener(
        'keydown',
        this.onDocumentKeydown
      );

      this.disconnectStickyHeaderObservers();
      this.restoreStickyAncestors();
      this.flickity?.destroy();
      this.flickity = null;
      document.documentElement.style.removeProperty('overflow');
    }
  }

  const initSection = (section) => {
    if (!section || instances.has(section)) return;

    const instance = new FajServiceProductV13(section);
    instances.set(section, instance);
    instance.init();
  };

  const destroySection = (section) => {
    const instance = instances.get(section);
    if (!instance) return;

    instance.destroy();
    instances.delete(section);
  };

  const initAll = (root = document) => {
    if (root.matches?.('[data-fajsp]')) {
      initSection(root);
    }

    root.querySelectorAll?.('[data-fajsp]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.('[data-fajsp]')) {
      destroySection(event.target);
    }

    event.target
      .querySelectorAll?.('[data-fajsp]')
      .forEach(destroySection);
  });
})();
